(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.btnHeaderMobile = btnHeaderMobile;
var _outsideClick = _interopRequireDefault(require("../helpers/outsideClick.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function btnHeaderMobile() {
  // btn mobile
  var headerBtnMobile = document.querySelector('[data-header="btn-mobile"]');
  if (headerBtnMobile) {
    var handleClickHeaderBtn = function handleClickHeaderBtn(event) {
      event.preventDefault();
      html.classList.toggle("overflow-mobile");
      headerNav.classList.toggle("active");
      headerBtnMobile.classList.toggle("active");
      headerOverlay.classList.toggle("active");
      (0, _outsideClick["default"])({
        element: headerNav,
        events: ["click"],
        callback: function callback() {
          html.classList.remove("overflow-mobile");
          headerNav.classList.remove("active");
          headerBtnMobile.classList.remove("active");
          headerOverlay.classList.remove("active");
        }
      });
    };
    var html = document.documentElement;
    var headerNav = document.querySelector('[data-header="nav"]');
    var headerOverlay = document.querySelector('[data-header="overlay"]');
    headerBtnMobile.addEventListener("click", handleClickHeaderBtn);
  }
}

},{"../helpers/outsideClick.js":3}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerInternLinks = headerInternLinks;
function headerInternLinks() {
  var internLinks = document.querySelectorAll("[data-header=\"nav\"] li a[href^=\"#\"]");
  if (internLinks.length) {
    var scrollToSection = function scrollToSection() {
      var isMax991px = window.matchMedia("(max-width: 991px)").matches;
      var headerBtnMobile = document.querySelector('[data-header="btn-mobile"]');
      if (isMax991px) {
        headerBtnMobile.click();
      }
    };
    internLinks.forEach(function (link) {
      link.addEventListener("click", scrollToSection);
    });
  }
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function outsideClick(_ref) {
  var element = _ref.element,
    events = _ref.events,
    callback = _ref.callback;
  var html = document.documentElement;
  var outside = 'data-outside';
  if (!element.hasAttribute(outside)) {
    events.forEach(function (userEvent) {
      setTimeout(function () {
        html.addEventListener(userEvent, handleOutsideClick);
      });
    });
    element.setAttribute(outside, '');
  }
  function handleOutsideClick(event) {
    if (!element.contains(event.target)) {
      element.removeAttribute(outside);
      events.forEach(function (userEvent) {
        html.removeEventListener(userEvent, handleOutsideClick);
      });
      callback();
    }
  }
}
var _default = exports["default"] = outsideClick;

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.heroChangeLogosOnMobile = heroChangeLogosOnMobile;
function heroChangeLogosOnMobile() {
  var logos = document.querySelectorAll('[data-hero="logos"] li');
  var isMax599px = window.matchMedia("(max-width: 599px)").matches;
  if (logos && isMax599px) {
    var findIndexMessageActive = function findIndexMessageActive() {
      var optionActiveIndex = Array.from(logos).findIndex(function (option) {
        if (option.classList.contains("active")) return option;
      });
      return optionActiveIndex;
    };
    setInterval(function () {
      var messageActiveIndex = findIndexMessageActive();
      var indexElementToActive = null;
      if (messageActiveIndex === logos.length - 1) {
        indexElementToActive = 0;
      } else {
        indexElementToActive = messageActiveIndex + 1;
      }
      logos.forEach(function (message) {
        return message.classList.remove("active");
      });
      logos[indexElementToActive].classList.add("active");
    }, 3000);
  }
}

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.methodVideo = methodVideo;
function methodVideo() {
  var videoBtn = document.querySelector('[data-method="video-btn"]');
  if (videoBtn) {
    var handleClickVideoBtn = function handleClickVideoBtn(event) {
      event.preventDefault();
      videoThumb.classList.remove("active");
      _videoBtn.classList.remove("active");
      video.currentTime = 0;
      video.play();
      setTimeout(function () {
        video.setAttribute("controls", true);
      }, 1000);
    };
    var resetVideo = function resetVideo() {
      videoThumb.classList.add("active");
      _videoBtn.classList.add("active");
      video.removeAttribute("controls");
    };
    var video = document.querySelector('[data-method="video"]');
    var _videoBtn = document.querySelector('[data-method="video-btn"]');
    var videoThumb = document.querySelector('[data-method="video-thumb"]');
    video.addEventListener("pause", resetVideo, false);
    video.addEventListener("ended", resetVideo, false);
    _videoBtn.addEventListener("click", handleClickVideoBtn);
  }
}

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.testimonials = testimonials;
function testimonials() {
  var testimonials = document.querySelector('[data-testimonials="slider"]');
  if (testimonials) {
    var testimonialsSwiper = new Swiper('[data-testimonials="slider"]', {
      centerInsufficientSlides: true,
      slidesPerView: 1.2,
      speed: 400,
      spaceBetween: 16,
      navigation: {
        prevEl: '[data-testimonials="slider-prev"]',
        nextEl: '[data-testimonials="slider-next"]'
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 32
        },
        992: {
          slidesPerView: 2.4,
          spaceBetween: 32
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 32
        }
      }
    });
  }
}

},{}],7:[function(require,module,exports){
"use strict";

var _btnHeaderMobile = require("./modules/global/btnHeaderMobile.js");
var _headerInternLinks = require("./modules/global/headerInternLinks.js");
var _heroChangeLogosOnMobile = require("./modules/pages/home/heroChangeLogosOnMobile.js");
var _methodVideo = require("./modules/pages/home/methodVideo.js");
var _testimonials = require("./modules/pages/home/testimonials.js");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(0, _btnHeaderMobile.btnHeaderMobile)();
(0, _headerInternLinks.headerInternLinks)();
(0, _heroChangeLogosOnMobile.heroChangeLogosOnMobile)();
(0, _methodVideo.methodVideo)();
(0, _testimonials.testimonials)();
window.addEventListener("load", function () {
  // AOS
  var isMax991px = window.matchMedia("(max-width: 991px)").matches;
  if (isMax991px) {
    AOS.init({
      once: true,
      duration: 650,
      offset: 260
    });
  } else {
    AOS.init({
      once: true,
      duration: 650,
      offset: 200
    });
  }
});
document.addEventListener("DOMContentLoaded", function () {
  var form = document.querySelector(".form-box");
  if (form) {
    form.addEventListener("submit", function (e) {
      var valid = true;
      var camposObrigatorios = ["nome", "email", "segmento", "instagram_ou_site", "tempo_negocio", "qtd_colaboradores", "media_vendas", "faturamento_mensal", "problemas", "investimento_marketing", "como_conheceu", "whatsapp"];
      camposObrigatorios.forEach(function (campo) {
        var input = document.querySelector("[name=\"".concat(campo, "\"]"));
        if (input && !input.value.trim()) {
          valid = false;
          input.classList.add("campo-erro");
          if (!input.nextElementSibling || !input.nextElementSibling.classList.contains("erro-msg")) {
            var msg = document.createElement("span");
            msg.className = "erro-msg";
            msg.textContent = "Campo obrigatório";
            input.parentNode.appendChild(msg);
          }
        } else if (input) {
          var _input$nextElementSib;
          input.classList.remove("campo-erro");
          if ((_input$nextElementSib = input.nextElementSibling) !== null && _input$nextElementSib !== void 0 && _input$nextElementSib.classList.contains("erro-msg")) {
            input.nextElementSibling.remove();
          }
        }
      });
      if (!valid) {
        e.preventDefault(); // impede envio
        return false;
      }
    });
  }
  var query = location.search.slice(1);
  var listUtms = {
    "utm-source": "ouse_utm_source",
    "utm-medium": "ouse_utm_medium",
    "utm-campaign": "ouse_utm_campaign",
    "utm-content": "ouse_utm_content",
    "utm-term": "ouse_utm_term",
    "codigo-indicacao": "ouse_codigo_indicacao"
  };
  if (query) {
    var dados = query.split("&");
    var dadosLimpos = {};
    dados.forEach(function (dados) {
      var campo = dados.split("=");
      var chave = campo[0];
      var valor = campo[1];
      dadosLimpos[chave] = valor;
      document.cookie = listUtms[chave] + "=" + valor + ";path=/";
    });
  }
  for (var key in listUtms) {
    var inputUtm = document.querySelector("input[name=\"".concat(key, "\"]"));
    if (inputUtm) {
      console.log(key);
      inputUtm.value = getCookie(listUtms[key]);
    }
  }
  function getCookie(nome) {
    var cookies = document.cookie.split("; ");
    for (var i = 0; i < cookies.length; i++) {
      var _cookies$i$split = cookies[i].split("="),
        _cookies$i$split2 = _slicedToArray(_cookies$i$split, 2),
        chave = _cookies$i$split2[0],
        valor = _cookies$i$split2[1];
      if (chave === nome) {
        return decodeURIComponent(valor);
      }
    }
    return null;
  }
});

},{"./modules/global/btnHeaderMobile.js":1,"./modules/global/headerInternLinks.js":2,"./modules/pages/home/heroChangeLogosOnMobile.js":4,"./modules/pages/home/methodVideo.js":5,"./modules/pages/home/testimonials.js":6}]},{},[7]);
